export enum OrderResultMessageEnum {
  OrderPayedSuccessfully = 'OrderPayedSuccessfully',
  OrderPaymentOperationFailed = 'OrderPaymentOperationFailed',
}
